module.exports = __webpack_public_path__ + "media/images/png/close-529bc7e1cd84ac0dc49bc4f67cec7ad9.png";